import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useMemberStats() {
  return useQuery({
    queryKey: ['stats', 'members'],
    queryFn: api.getMemberStats,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export function useTransferredRequests() {
  return useQuery({
    queryKey: ['stats', 'transferred'],
    queryFn: api.getTransferredRequests,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export function useCompletedRequests() {
  return useQuery({
    queryKey: ['stats', 'completed'],
    queryFn: api.getCompletedRequests,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
